import { Box, Card, Group, ScrollArea, Text } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import B2bTable from "components/reusable/b2bTable";
import ExportComponent from "utiles/export";
import { formatNumber, formatStatus } from "utiles/url";

const DetaileTable = ({ ordersList, userName, totalAmount }) => {
  const headerData = [
    {
      label: "#",
      key: "index",
      sortable: false,
      searchable: false,
      width: "5%",
      render: (_rowData, rowIndex) => <span>{rowIndex + 1}</span>,
    },
    {
      label: "Warehouse Name",
      key: "warehouse_name",
      sortable: false,
      searchable: true,
      width: "15%",
      render: (rowData) => {
        return rowData?.warehouse_name;
      },
    },
    {
      label: "Supplier Name",
      key: "supplier_name",
      sortable: false,
      searchable: true,
      width: "17%",
      render: (rowData) => {
        return rowData?.supplier_name;
      },
    },
    {
      label: "Business Name",
      key: "supplier_business_name",
      sortable: false,
      searchable: true,
      width: "15%",
      render: (rowData) => {
        return rowData?.supplier_business_name;
      },
    },
    {
      label: "Payment Method",
      key: "payment_method",
      sortable: false,
      searchable: true,
      width: "7%",
      render: (rowData) => {
        return <span>{formatStatus(rowData?.payment_method)}</span>;
      },
    },
    {
      label: "Amount",
      key: "amount",
      sortable: false,
      searchable: false,
      width: "7%",
      render: (rowData) => <span>{formatNumber(rowData.amount)}</span>,
    },
    {
      label: "Type",
      key: "type",
      sortable: false,
      searchable: false,
      width: "10%",
      render: (rowData) => <span>{formatStatus(rowData.type)}</span>,
    },
    {
      label: "Date",
      key: "date_time",
      sortable: false,
      searchable: false,
      render: (rowData) => (
        <span>
          {new Date(rowData.date).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}
        </span>
      ),
    },
  ];

  const { height } = useViewportSize();
  const computedTotal =
    totalAmount ??
    (ordersList || []).reduce((sum, row) => sum + (row.amount || 0), 0);

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      {/* Header: user name + Transactions title + Export button */}
      <Group position="apart" align="center" mb="sm" px="xs">
        <Box>
          {userName && (
            <Text weight={700} size="lg">
              {userName}
            </Text>
          )}
          <Text weight={600} size="md" color="dimmed">
            Transactions
          </Text>
        </Box>
        <ExportComponent
          data={ordersList || []}
          headers={headerData}
          reportTitle="Retailer Transactions Detail"
          fileNamePrefix={`retailer_${userName || "detail"}_transactions`}
          userName={userName}
          totalAmount={formatNumber(computedTotal)}
        />
      </Group>

      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <Card shadow="sm" p="lg">
          <ScrollArea>
            <B2bTable
              header={headerData}
              data={ordersList || []}
              layout={{ minWidth: 700 }}
              total={1}
              searchInput={false}
              activePage={1}
              loading={false}
            />
          </ScrollArea>
          {/* Total amount footer */}
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "12px",
              paddingRight: "8px",
            }}
          >
            <Text weight={700} size="sm">
              Total Amount: {formatNumber(computedTotal)}
            </Text>
          </Box>
        </Card>
      </ScrollArea>
    </div>
  );
};

export default DetaileTable;
